/**
 * TODO Replace qr-code-styling with another lib
 *  There are a few problems:
 *   - unmaintained
 *   - https://github.com/kozakdenys/qr-code-styling/issues/92
 *   - https://github.com/kozakdenys/qr-code-styling/issues/125
 *   - https://github.com/kozakdenys/qr-code-styling/issues/49
 *   - https://github.com/sallandpioneers/qr-code-styling/commit/638824f8561b165c529f99c88e4af3ad56e99021
 *   - https://github.com/kozakdenys/qr-code-styling/issues/49
 *   - https://github.com/kozakdenys/qr-code-styling/issues/60
 *   Maybe this one fits better, but no styles:
 *   https://github.com/soldair/node-qrcode
 */
import React, { useEffect, useRef, useState} from "react";
import { useTranslation } from "react-i18next";

import Button from "~/components/Button";
import FormGroup from "~/components/FormGroup";
import ColorInput from "~/components/forms/ColorInput";
import SelectInput from "~/components/forms/SelectInput";
import TextInput from "~/components/forms/TextInput";
import Label from "~/components/Label";
import QRCodeStyling, {
    CornerDotType,
    CornerSquareType,
    DotType,
    DrawType,
    ErrorCorrectionLevel,
    FileExtension,
    Mode,
    Options,
    TypeNumber
} from "~/helpers/qr.client";

interface Props {
    data: string | null;
    tkey: string;
}

const QRCodeGenerator: React.FC<Props> = (
    {
        data = null,
      tkey,
}) => {
    const { t } = useTranslation("translations");

    const [options, setOptions] = useState<Options>({
        width: 200,
        height: 200,
        type: 'svg' as DrawType,
        // image: 'https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg',
        margin: 5,
        qrOptions: {
            typeNumber: 0 as TypeNumber,
            mode: 'Byte' as Mode,
            errorCorrectionLevel: 'Q' as ErrorCorrectionLevel
        },
        imageOptions: {
            hideBackgroundDots: true,
            imageSize: 0.4,
            margin: 10,
            crossOrigin: 'anonymous',
        },
        dotsOptions: {
            color: '#222222',
            // gradient: {
            //   type: 'linear', // 'radial'
            //   rotation: 0,
            //   colorStops: [{ offset: 0, color: '#8688B2' }, { offset: 1, color: '#77779C' }]
            // },
            type: 'rounded-sm' as DotType
        },
        backgroundOptions: {
            color: '#fff',
            // gradient: {
            //   type: 'linear', // 'radial'
            //   rotation: 0,
            //   colorStops: [{ offset: 0, color: '#ededff' }, { offset: 1, color: '#e6e7ff' }]
            // },
        },
        cornersSquareOptions: {
            color: '#222222',
            type: 'extra-rounded' as CornerSquareType,
            // gradient: {
            //   type: 'linear', // 'radial'
            //   rotation: 180,
            //   colorStops: [{ offset: 0, color: '#25456e' }, { offset: 1, color: '#4267b2' }]
            // },
        },
        cornersDotOptions: {
            color: '#222222',
            type: 'dot' as CornerDotType,
            // gradient: {
            //   type: 'linear', // 'radial'
            //   rotation: 180,
            //   colorStops: [{ offset: 0, color: '#00266e' }, { offset: 1, color: '#4060b3' }]
            // },
        }
    });
    const [fileExt, setFileExt] = useState<FileExtension>("svg");
    const [style, setStyleState] = useState<"square" | "rounded-sm" | "classy">("rounded-sm");
    const [qrCode] = useState<QRCodeStyling>(new QRCodeStyling(options));
    const ref = useRef<HTMLDivElement>(null);
    const swatches = [
        '#fff',
        '#000',
        '#264653',
        '#2a9d8f',
        '#ec5791',
        '#f4a261',
        '#e76f51',
        '#d62828',
        '#023e8a',
        '#0077b6',
        '#0096c7',
        '#00b4d8',
    ];

    useEffect(() => {
        if (ref.current) {
            qrCode.append(ref.current);
        }
    }, [qrCode, ref]);

    useEffect(() => {
        if (!qrCode) return;
        options.data = data ?? 'https://countlike.pro';

        qrCode.update(options);
        if (ref.current && ref.current.firstChild) {
            (ref.current.firstChild as HTMLElement).setAttribute('viewBox', `0 0 ${options.width} ${options.height}`)
        }
    }, [qrCode, options, data]);


    useEffect(() => {
        if (!qrCode) return;
        qrCode.update(options);
        if (ref.current && ref.current.firstChild) {
            (ref.current.firstChild as HTMLElement).setAttribute('viewBox', `0 0 ${options.width} ${options.height}`)

        }
    }, [data]);


    if (data === null) {
        return;
    }

    const onDownloadClick = () => {
        if (!qrCode) return;
        qrCode.download({
            extension: fileExt
        });
    };

    function setStyle(type: "square" | "rounded-sm" | "classy") {
        switch (type) {
            case 'square':
                setOptions(options => ({
                    ...options,
                    dotsOptions: {
                        ...options.dotsOptions,
                        type: 'square' as DotType,
                    },
                    cornersSquareOptions: {
                        ...options.cornersSquareOptions,
                        type: 'square' as CornerSquareType,
                    },
                    cornersDotOptions: {
                        ...options.cornersDotOptions,
                        type: 'square' as CornerDotType,
                    },
                }))
                break;
            case 'rounded-sm':
                setOptions(options => ({
                    ...options,
                    dotsOptions: {
                        ...options.dotsOptions,
                        type: 'rounded-sm' as DotType,
                    },
                    cornersSquareOptions: {
                        ...options.cornersSquareOptions,
                        type: 'extra-rounded' as CornerSquareType,
                    },
                    cornersDotOptions: {
                        ...options.cornersDotOptions,
                        type: 'dot' as CornerDotType,
                    },
                }))
                break;
            case 'classy':
                setOptions(options => ({
                    ...options,
                    dotsOptions: {
                        ...options.dotsOptions,
                        type: 'classy' as DotType,
                    },
                    cornersSquareOptions: {
                        ...options.cornersSquareOptions,
                        type: 'extra-rounded' as CornerSquareType,
                    },
                    cornersDotOptions: {
                        ...options.cornersDotOptions,
                        type: 'dot' as CornerDotType,
                    },
                }))
                break;
            default:
                return;
        }
        setStyleState(type);
    }

    return (
        <>
            <div className="flex flex-col gap-6 md:flex-row py-6">
                <div className="flex-1">
                    <div className="flex flex-col gap-6">
                        <FormGroup>
                            <Label
                              htmlFor="style"
                              text={t(`${tkey}.style`)}
                            />
                            <SelectInput
                                name="style"
                                onChange={(value) => setStyle(value as string)}
                                value={style}
                                options={[
                                    {name: t(`${tkey}.style_rounded`), value: "rounded-sm"},
                                    {name: t(`${tkey}.style_square`), value: "square"},
                                    {name: t(`${tkey}.style_classy`), value: "classy"},
                                ]}
                            />
                        </FormGroup>
                        <div className="flex gap-4">
                            <FormGroup>
                                <Label
                                    htmlFor="backgroundColor"
                                    text={t(`${tkey}.background_color`)}
                                />
                                <ColorInput
                                    name="backgroundColor"
                                    defaultValue={options.backgroundOptions?.color}
                                    swatches={swatches}
                                    onChange={(value) => {
                                        const isValidHexColor = (str: string) => /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{4}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/.test(str);
                                        if (!isValidHexColor(value)) {
                                            return;
                                        }

                                        setOptions(options => ({
                                            ...options,
                                            backgroundOptions: {
                                                ...options.backgroundOptions,
                                                color: value
                                            }
                                        }))
                                    }}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label
                                    htmlFor="foregroundColor"
                                    text={t(`${tkey}.foreground_color`)}
                                />
                                <ColorInput
                                    name="foregroundColor"
                                    defaultValue={options.dotsOptions?.color}
                                    swatches={swatches}
                                    onChange={(value) => {
                                        const isValidHexColor = (str: string) => /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{4}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/.test(str);
                                        if (!isValidHexColor(value)) {
                                            return;
                                        }

                                        setOptions(options => ({
                                            ...options,
                                            dotsOptions: {
                                                ...options.dotsOptions,
                                                color: value
                                            },
                                            cornersSquareOptions: {
                                                ...options.cornersSquareOptions,
                                                color: value
                                            },
                                            cornersDotOptions: {
                                                ...options.cornersDotOptions,
                                                color: value
                                            },
                                        }))
                                    }}
                                />
                            </FormGroup>
                        </div>
                        <div className="flex gap-4">
                            <FormGroup>
                                <Label
                                    htmlFor="margin"
                                    text={t(`${tkey}.margin`)}
                                />
                                <TextInput
                                    type="text"
                                    name="margin"
                                    value={options.margin}
                                    onChange={(value) => {
                                        setOptions(options => ({
                                            ...options,
                                            margin: parseInt(value) || 0
                                        }))
                                    }}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label
                                    htmlFor="size"
                                    text={t(`${tkey}.size`)}
                                />
                                <TextInput
                                    type="text"
                                    name="size"
                                    value={options.width}
                                    onChange={(value) => {
                                        setOptions(options => ({
                                            ...options,
                                            width: parseInt(value) || 200,
                                            height: parseInt(value) || 200,
                                        }))
                                    }}
                                />
                            </FormGroup>

                        </div>
                    </div>
                </div>
                <div
                    className="w-full md:w-[260px] md:h-[260px] p-[30px] flex justify-center bg-opacity-10 bg-gray-500 border border-solid border-gray-500 rounded-[20px]">
                    <div ref={ref} className="w-[200px] h-[200px] fit-svg"/>
                </div>
            </div>
            <FormGroup layout="row">
                <Label
                    htmlFor="fileExtension"
                    text={t(`${tkey}.export_as`)}
                />
                <div className="flex flex-row">
                    <div className="flex flex-col flex-6">
                        <SelectInput
                            name="fileExtension"
                            onChange={(value) => setFileExt(value as FileExtension)}
                            value={fileExt}
                            options={[
                                {name: "SVG", value: "svg"},
                                {name: "PNG", value: "png"},
                                {name: "JPEG", value: "jpeg"},
                                {name: "WEBP", value: "webp"},
                            ]}
                            className="rounded-tr-none rounded-br-none pr-12"
                        />
                    </div>
                    <div className="flex flex-col flex-6">
                        <Button
                            className={"rounded-tl-none rounded-bl-none h-full"}
                            onClick={onDownloadClick}
                        >
                            {t(`${tkey}.download`)}
                        </Button>
                    </div>
                </div>
            </FormGroup>
        </>
    );
};

export default QRCodeGenerator;